import FixedFooter from "components/FixedFooter";
import React from "react";
import PlaceOrderButton, { MinOrder } from "./PlaceOrderButton";
import WalletPay from "helpers/payment_helpers/stripe/WalletPay";
import { useSelector } from "react-redux";
import C from "Constants";
import { TranslationText } from "components/TextTranslationContainer";
import { PriceRender } from "components/DisplayPrice";

const FootterWithTotalAmount = ({children, orderGrossAmount}) => {
  return (
    <FixedFooter
    containerStyleProps={{ className: "dummy-class" }}
    innerStyleProps={{
      className: "bg-dark-blue-100 p-4 ",
      style: {
        height: "auto",
      },
    }}
    // page={true}
  >
    <div className="flex justify-between items-center text-16x w-full font-bold">
      <TranslationText text="Total (inc. Tax)" />
      <PriceRender
        price={orderGrossAmount}
        className="dummy-class leading-none"
      />
    </div>
    <hr className="border-t-2 w-full my-4" />
    {children}
    </FixedFooter>
  )
}

function FooterWithWallet({
  cartTotal,
  integrationsByName,
  selectedStore,
  placeORder,
  Place_Order,
  cardProcessing,
  validateOrderShipping,
  minOrder,
  storePageUrl,
  orderGrossAmount,
  ...rest
}) {
  const { orderType } = useSelector((state) => state.AppReducer);

  if (minOrder > cartTotal && orderType?.EN?.name === C.SERVICE_TYPE.DELIVERY)
    return (
      <FootterWithTotalAmount orderGrossAmount={orderGrossAmount}>
        <MinOrder
          minOrder={minOrder || 0}
          cartTotal={cartTotal}
          storePageUrl={storePageUrl}
        />
      </FootterWithTotalAmount>
    );
  else if (integrationsByName[C.STRIPE])
    return (
      <WalletPay
        selectedStore={selectedStore}
        placeOrder={placeORder}
        payUsingWallet={validateOrderShipping}
      >
        <FootterWithTotalAmount orderGrossAmount={orderGrossAmount}>
          <PlaceOrderButton
            placeOrder={Place_Order}
            loading={cardProcessing}
            {...rest}
          />
        </FootterWithTotalAmount>
      </WalletPay>
    );
  return (
    <FootterWithTotalAmount orderGrossAmount={orderGrossAmount}>
      <PlaceOrderButton
        placeOrder={Place_Order}
        loading={cardProcessing}
        {...rest}
      />
    </FootterWithTotalAmount>
  );
}

export default FooterWithWallet;
